(function () {
    'use strict';

    angular.module('quantixApp').controller('CompanyDetailReportController',
        CompanyDetailReportController);

    CompanyDetailReportController.$inject = ['$scope', '$http', '$timeout', 'GenericServiceNew', 'ScorecardService', 'GenericService', '$filter', 'ivhTreeviewBfs', 'ivhTreeviewOptions', 'CompanyProfileService'];

    function CompanyDetailReportController($scope, $http, $timeout, GenericServiceNew, ScorecardService, GenericService, $filter, ivhTreeviewBfs, ivhTreeviewOptions, CompanyProfileService) {

        $scope.companyCode = "";
        $scope.showIndustryTree = false;
        var vm = this;
        var idss = new Array();
        $scope.adddd = {};
        var indgri = null;
        var arrayind = new Array();
        var allKeysInd = [];
        $scope.showPeerCompare = false;
        $scope.selectedIndss = {};
        $scope.selectedIndustries = [];
        var indfiltervaluchanged = false;
        $scope.showSubmitButton = false;
        var firstcharind = '';
        var filterselectall = false;
        $scope.showGenerateResult = false;
        $scope.irsIndustryName = [];
        vm.selectedirsIndustry = [];
        $scope.allCompanies = [];
        $scope.allCompaniesCode = [];
        $scope.companyPeerComparisonList = null;


        $scope.showFlag = false;
        $scope.format = 'DD-MM-YYYY';
        $scope.rangespan = 731;
        $scope.range = {
            start: moment().subtract(6, 'months').format('DD-MM-YYYY'),
            end: moment().format('DD-MM-YYYY')
        };
        var opts = ivhTreeviewOptions(),
            isExpanded = opts.expandedAttribute;
        $scope.searchFilterForCompanyDetailReport = function (typedthings) {
            if (typedthings == "cleanData") {
                $scope.companies = null;
            } else {

                GenericServiceNew
                    .getCompaniesListByNameNew(typedthings,
                        "COMPANYREPORTDETAILS")
                    .then(
                        function (data) {

                            $scope.companies = data;

                        });
            }

        }


        $scope.submitData = function () {

            $scope.showPeerCompare = true;
            $scope.showGenerateResult = true;
            $scope.gridIndustryTree();
            $scope.cntForIndusrty = 0;
            $scope.idStack = [];
            $scope.selectedIndustries = [];
            $scope.showIndustryTree = true;
            $scope.showFlag = true;
            $scope.flag = {
                litigationFlag: false,
                epfTransaction: '6',
                nonGstFlag: false,
                litigationToggleFlag: false,
                epfToggleFlag: false,
                fuzzyFlag: false,
                litigationsLinkedFlag: false
            };
        };


        $scope.setselectedvalcomp = function (obj) {

            $scope.selectedComp = obj;
            if ($scope.selectedComp != null) {
                vm.selectedirsIndustry = [];
                $scope.paramsValueData = [];
                $scope.finalIrsIndustryId = [];
                $scope.searchCompaniesWorkingCap = {
                    WoringCapital1: "",
                    WoringCapital2: "",
                    WoringCapital3: "",
                    WoringCapital4: ""
                };
                $scope.showIndustryTree = false;
                $scope.showPeerCompare = false;
                $scope.showFlag = false;
                $scope.companyCode = $scope.selectedComp.companyCode;
                $scope.companyName = $scope.selectedComp.companyName;
                $scope.industryId = $scope.selectedComp.industryId;
                $scope.ListingStatus = $scope.selectedComp.listedFlag;
                $scope.industryName = $scope.selectedComp.industryName;
                $scope.getPeerComparisonCompanyList();
                //  $scope.getPeerInfo();
                angular.forEach($scope.irsIndustryName, function (val, key) {

                    if (val.id == $scope.industryId) {

                        vm.selectedirsIndustry.push({
                            "id": val.id,
                            "name": val.name,
                            "labelName": val.labelName,
                            checked: true
                        });


                    }
                });

                $http({
                        url: 'api/companyProfile/getSegmentID',
                        method: 'POST',
                        data: $scope.companyCode
                        //responseType : 'arraybuffer'
                    })
                    .success(function (response) {
                        $scope.segmentId = response;

                        if ($scope.segmentId == 19 || $scope.segmentId == 18) {
                            $scope.showGenerateResult = false;
                            $scope.showSubmitButton = true;

                        } else {
                            $scope.showIndustryTree = false;
                            $scope.showFlag = true;
                            $scope.showGenerateResult = true;
                            $scope.showSubmitButton = false;
                            $scope.idStack = [];
                            $scope.selectedIndustries = [];
                            $scope.showPeerCompare = true;

                        }

                    });

            }


        }
        $scope.downloadDetailReport = function () {

            // $scope.companyCode = vm.searchCompaniesForDetails;
            $scope.finalIrsIndustryId = [];
            $scope.workingCapitalValue();

            if ($scope.isNotNumber) {
                $scope.downloadCompanyReportFinal();
            } else {
                alert("Working capital Value should be a number.");
            }


        }

        $scope.getNumberWithIndianCurrency = function (number) {
            number = number.toString();
            var lastThree = number.substring(number.length - 3);
            var otherNumbers = number.substring(0, number.length - 3);
            if (otherNumbers != '')
                lastThree = ',' + lastThree;
            var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
                lastThree;
            return res;
        }

        // Gics industry code

        $scope.gridIndustryTree = function () {

            $http.post('api/masterData/getMasterIndustryTreeData').success(
                function (data) {
                    $scope.sampleIndustrydata = data;
                    $scope.indTreeData = $scope.sampleIndustrydata;
                    $scope.temp = $scope.indTreeData;
                    $scope.selectedIndustries = [];
                    $scope.selectedIndustries.push($scope.industryName);
                    $scope.badgeStringInd = $scope.selectedIndustries.toString();

                }).error(function (data) {

            });

        }
        $scope.onDynamicLevelCind = function (event) {
            event.level.setEnableFooters(false);
            if (event.level.getNestDepth() > 1) {
                event.level.forcePagerRow = false;
            } else {
                event.level.forcePagerRow = true;
            }
        };

        $scope.disablecellind = function (cell) {
            return (cell.getLevel().getNestDepth() != 5);
        }
        $scope.onGridCreationCompletedIndustry = function (event) {

            if (event != null) {
                indgri = event.target;
                indgri.enableHeightAutoAdjust = true;
                indgri.validateNow();
                $scope.eventForGrid = event;

            } else {
                indgri.enableHeightAutoAdjust = true;
                indgri.clearFilter();
                indgri.expandAll();
                indgri.setFilterValue('label', firstcharind, indgri);
                indgri.validateNow();
            }
        };

        $scope.gettooltipforIndustry = function (item, column) {
            var html = "<label title='" + item.label + "'>" + item.label +
                "</label>"
            return html;
        };

        $scope.filerPageSortHandle = function (event) {
            setTimeout(
                function () {
                    var filter = event.target.getRootFilter();
                    var grid = event.target;
                    if (!filter.filterExpressions.length) {
                        grid.collapseAll();
                        grid.validateNow();
                        // grid.rebuild();
                        indfiltervaluchanged = false;

                    }
                    if (!indfiltervaluchanged) {
                        if (event.cause == "filterChange") {
                            if (filter.filterExpressions &&
                                filter.filterExpressions.length) {
                                firstcharind = filter.filterExpressions[0].expression
                                indfiltervaluchanged = true;
                                $scope
                                    .onGridCreationCompletedIndustry(null);
                            }
                        }
                    }
                }, 1);
        };

        $scope.ind = {
            indstatus: false
        };
        $scope.ind.indstatus = false;
        $scope.cntForIndusrty = 0;

        $scope.setIndustryTree = function () {

            $scope.ind.indstatus = true;
            // $scope.showResult = false;

            $scope.gridOptionsSec = {
                dataProvider: $scope.sampleIndustrydata,
                delegate: $scope
            };



            if ($scope.cntForIndusrty == 0) {
                $scope.cntForIndusrty = 1;
                $timeout(function () {
                    var l = document.getElementById('industryButton');
                    l.click();
                }, 100, false);

            }

            if ($scope.industryId != null) {
                var peerGroup1IndustryGridKeystemp = $scope.industryId
                    .split(",");
                arrayind = [];
                $scope.selectedIndustries = [];
                $scope.idStack = [];

                ivhTreeviewBfs(
                    $scope.sampleIndustrydata,
                    function (node) {
                        for (var i = 0; i < peerGroup1IndustryGridKeystemp.length; i++) {

                            if (node.id == peerGroup1IndustryGridKeystemp[i]) {
                                $scope.selectedIndustries
                                    .push(node.label);
                                $scope.idStack.push(node.id);

                                arrayind
                                    .push(node.label);
                            }
                        }
                    });

                if ($scope.eventForGrid != undefined) {
                    indgri = $scope.eventForGrid.target;
                    indgri.enableHeightAutoAdjust = true;
                    indgri.validateNow();
                }
                indgri
                    .setSelectedKeys(
                        peerGroup1IndustryGridKeystemp,
                        true);



                $scope.badgeStringInd = $scope.selectedIndustries
                    .toString();
            }
        }

        $scope.selectAllind = function (flag) {
            allKeysInd = [];
            if (flag) {
                $scope.noinddata = false;
                arrayind = [];
                $scope.selectedIndustries = [];
                if (indfiltervaluchanged) {
                    filterselectall = true;
                    $scope.industryall = false;
                } else {
                    filterselectall = false;
                    $scope.industryall = true;
                }

                ivhTreeviewBfs($scope.sampleIndustrydata, opts, function (node) {

                    if (indfiltervaluchanged) {

                        if (node.label.toLowerCase().includes(firstcharind)) {
                            $scope.selectedIndustries.push(node.id);
                            allKeysInd.push(node.id);
                            if (node.children.length > 0) {
                                ivhTreeviewBfs(node, opts, function (childnode) {
                                    allKeysInd.push(childnode.id);
                                });
                            }

                        }

                    } else {
                        allKeysInd.push(node.id);
                    }

                });

                $scope.badgeStringInd = $scope.selectedIndustries.toString();

                $timeout(function () {
                    indgri.setSelectedKeys(allKeysInd, true);
                }, 100);
            } else {
                arrayind = [];
                $scope.selectedIndustries = [];
                $scope.industryId = null;
                $scope.industryall = false;
                if (indgri != null) {
                    indgri.clearSelection();
                    indgri.clearAllFilters();
                    indgri.clearChanges();
                    indfiltervaluchanged = false;
                    indgri.collapseAll();
                    indgri.validateNow();
                }

                idss = [];
                $scope.idStack = [];
                // indgri.rebuild();
                // alert($scope.selectedProducts);
            }
        }

        $scope.getChildIndustry = function (childArray) {

            if (childArray.children.length <= 0) {
                $scope.idStack.push(childArray.id);
                return childArray.id;
            } else {
                for (var i = 0; i < childArray.children.length; i++) {
                    var childArr = childArray.children[i];
                    // return $scope.getChildIndustry(childArr);
                    $scope.getChildIndustry(childArr);
                }
            }

        }

        $scope.spliceChildIndustry = function (childArray) {
            var subchild = childArray.children[0];
            if (childArray.children.length <= 0 ||
                angular.isUndefined(subchild.id) ||
                subchild.id == childArray.id) {
                $scope.idStack.splice($scope.idStack.indexOf(childArray.id), 1);
            } else {
                for (var i = 0; i < childArray.children.length; i++) {
                    var childArr = childArray.children[i];
                    $scope.spliceChildIndustry(childArr);
                }
            }

        }

        $scope.idStack = [];
        idss = new Array();
        var selectedIndArray = new Array();
        $scope.setbadgesforIndustry = function (evt) {
            var grid = evt.target;
            if (evt.isItemSelected) {
                $scope.noinddata = false;
                selectedIndArray.push(evt);
                arrayind.push(evt.item.label);
                $scope.industryId = evt.item.id;
                $scope.selectedIndss = selectedIndArray
                if (evt.item.children.length > 0) {
                    for (var i = 0; i < evt.item.children.length; i++) {
                        var childArr = evt.item.children[i];
                        var id = $scope.getChildIndustry(childArr);
                        idss.push(id);
                    }
                } else {
                    idss.push(evt.item.id);
                    $scope.idStack.push(evt.item.id)

                }
            } else {
                selectedIndArray.splice(selectedIndArray.indexOf(evt.item.label), 1);
                $scope.selectedIndss = selectedIndArray;
                if (evt.item.children.length == 0) {
                    if (idss.indexOf(evt.item.id) != -1) {
                        idss.splice(idss.indexOf(evt.item.id), 1);
                    }
                    if ($scope.idStack.indexOf(evt.item.id) != -1) {
                        $scope.idStack.splice($scope.idStack
                            .indexOf(evt.item.id), 1);
                    }
                } else {
                    idss.splice(idss.indexOf(evt.item.id),
                        evt.item.children.length);
                    for (var i = 0; i < evt.item.children.length; i++) {
                        var childArr = evt.item.children[i];
                        $scope.spliceChildIndustry(childArr);
                    }

                }

                if (arrayind.indexOf(evt.item.label) != -1) {
                    arrayind.splice(arrayind.indexOf(evt.item.label), 1);
                } else if ($scope.industryall) {
                    $scope.industryall = false;
                    arrayind = [];
                    arrayind.push("Multiple Industries selected");
                } else if (indgri.getSelectedObjects().length > 1) {
                    arrayind = [];
                    arrayind.push("Multiple Industries selected");
                } else {
                    arrayind = [];
                }
            }
            $timeout(
                function () {
                    $scope.selectedIndustries = angular.copy(arrayind);
                    $scope.badgeStringInd = $scope.selectedIndustries
                        .toString();

                    if ($scope.badgeStringInd.length > 30) {
                        for (var i = 0; i < $scope.selectedIndustries.length; i++) {
                            if ($scope.selectedIndustries[i].length > 10) {
                                $scope.selectedIndustries[i] = $scope.selectedIndustries[i]
                                    .substr(0, 14) +
                                    '..';
                            }
                        }
                        $scope.badgeStringInd = $scope.selectedIndustries
                            .toString();
                    } else {
                        $scope.badgeStringInd = $scope.selectedIndustries
                            .toString();
                    }
                }, 100);
        }


        $scope.getIrsIndustryName = function () {

            GenericService.getIrsIndustryName().then(function (data) {
                $scope.irsIndustryName = data;

            });
        }

        $scope.selectAll = {
            checked: false
        };
        $scope.changeAgencies = function (selectAll) {
            if (selectAll) {
                angular.forEach($scope.irsIndustryName, function (val, key) {
                    val.chekced = true;
                });
            } else {
                angular.forEach($scope.irsIndustryName, function (val, key) {
                    val.chekced = false;
                });
            }

        }

        $scope.paramsValueData = [];
        $scope.getPeerComparisonCompanyList = function () {
            CompanyProfileService.getPeerData($scope.companyCode)
                .then(
                    function (data) {
                        $scope.companyPeerComparisonList = data;

                        angular.forEach($scope.companyPeerComparisonList, function (company) {

                            $scope.paramsValueData.push(company.basicInfo[0].paramList);

                        })


                        if ($scope.companyCode != null &&
                            $scope.companyPeerComparisonList.length == 0) {
                            $scope.allCompanies
                                .push($scope.companyName);
                            $scope.allCompaniesCode
                                .push($scope.companyCode);
                        } else if ($scope.companyPeerComparisonList.length > 0) {
                            $scope.allCompanies = $scope.companyPeerComparisonList[0].paramList;
                            $scope.allCompaniesCode = $scope.companyPeerComparisonList[0].listComCode;
                            $scope.paramsList = $scope.companyPeerComparisonList[0].basicInfo[0].paramsVal;

                        }

                        $scope.selectedCompanyName = [];
                        $scope.selectedCompanyCode = [];

                        // get filter list of compnaies

                        $("#companyRef1").css({
                            "pointer-events": "none",
                            opacity: "0.8"
                        });
                        $scope.searchCompanies1 = $scope.companyName;
                        $scope.searchCompaniesCode1 = $scope.companyCode;
                        $scope.companyCodeForSelected1 = $scope.companyName;
                        $scope.companyForSelected1 = $scope.companyCode;
                        $scope.selectedCompanyName.push($scope.searchCompanies1);
                        $scope.selectedCompanyCode.push($scope.searchCompaniesCode1);


                        if ($scope.allCompanies != undefined &&
                            $scope.allCompanies[1] != undefined) {
                            $scope.searchCompanies2 = $scope.allCompanies[1];
                            $scope.selectedCompanyName.push($scope.searchCompanies2);
                            $scope.searchCompaniesCode2 = $scope.allCompaniesCode[1];
                            $scope.selectedCompanyCode.push($scope.searchCompaniesCode2);

                            $scope.companyForSelected2 = $scope.searchCompaniesCode2;
                            $scope.companyCodeForSelected2 = $scope.searchCompanies2;
                        } else {
                            $scope.searchCompanies2 = "";
                        }
                        if ($scope.allCompanies != undefined &&
                            $scope.allCompanies[2] != undefined) {
                            $scope.searchCompanies3 = $scope.allCompanies[2];
                            $scope.selectedCompanyName.push($scope.searchCompanies3);
                            $scope.searchCompaniesCode3 = $scope.allCompaniesCode[2];
                            $scope.selectedCompanyCode.push($scope.searchCompaniesCode3);
                            $scope.companyForSelected3 = $scope.searchCompaniesCode3;
                            $scope.companyCodeForSelected3 = $scope.searchCompanies3;
                        } else {

                            $scope.searchCompanies3 = "";
                        }
                        if ($scope.allCompanies != undefined &&
                            $scope.allCompanies[3] != undefined) {
                            $scope.searchCompanies4 = $scope.allCompanies[3];
                            $scope.selectedCompanyName.push($scope.searchCompanies4);
                            $scope.searchCompaniesCode4 = $scope.allCompaniesCode[3];
                            $scope.selectedCompanyCode.push($scope.searchCompaniesCode4);
                            $scope.companyForSelected4 = $scope.searchCompaniesCode4;
                            $scope.companyCodeForSelected4 = $scope.searchCompanies4;
                        } else {
                            $scope.searchCompanies4 = "";
                        }






                    },
                    function (errordata) {
                        if (errordata.status == 403) {
                            $scope.errorPeerComparison = true;
                            $scope.errorMessagePeerComparison = "This section is not available in your current subscription. To subscribe to the latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
                        } else {
                            $scope.error = true;
                            $scope.errorMessages = "Something went wrong, please try again in some time. If the problem persists, please contact Administrator.";
                            $timeout(function () {

                                $scope.error = false;
                                $scope.errorMessage = "";

                            }, 2000);
                        }

                    });
        }

        // get filter list of compnaies for peer comparison
        $scope.searchFilterForPeerComparison = function (typedthings) {
            // when $watch is executing companyCode is null , it will be get
            // after selecting a compnay
            if ($scope.searchCompanies1 == "") {
                $scope.errorMessage = "Please select Reference company1 first";
                $scope.error = true;
                $timeout(function () {

                    $scope.error = false;
                    $scope.errorMessage = "";

                }, 2000);

            }
            if (typedthings == "cleanData") {
                $scope.companies = null;
            } else {
                CompanyProfileService
                    .getCompaniesListByNameForPeerComparison(typedthings,
                        $scope.searchCompanies1)
                    .then(
                        function (data) {
                            $scope.companies = data;

                            if ($scope.companies.length == 0) {
                                $scope.errorMessage = "Please search the appropriate company!";
                                $scope.error = true;
                            }
                        },
                        function (errordata) {
                            $scope.errorMessage = "Error while searching company!";
                            $scope.error = true;
                        });

                $timeout(function () {

                    $scope.error = false;
                    $scope.errorMessage = "";

                }, 3000);
            }

        }



        $scope.compareAllPeerForCompanyReport = function () {

            if ($scope.searchCompanies1 != "" &&
                $scope.companyForSelected1 == undefined) {

                $scope.searchCompanies1 = "";
            }


            if (($scope.searchCompanies1 != "")) {


                if ($scope.searchCompanies4 != "" &&
                    $scope.companyForSelected4 == undefined) {

                    $scope.searchCompanies4 = undefined;
                }
                if ($scope.searchCompanies3 != "" &&
                    $scope.companyForSelected3 == undefined) {

                    $scope.searchCompanies3 = undefined;
                }
                if ($scope.searchCompanies2 != "" &&
                    $scope.companyForSelected2 == undefined) {

                    $scope.searchCompanies2 = undefined;
                }



                if ($scope.selectedCompanyName.indexOf($scope.searchCompanies4) == -1 &&
                    $scope.searchCompanies4 != "" &&
                    $scope.searchCompanies4 != undefined &&
                    $scope.companyForSelected4 != undefined) {

                    $scope.selectedCompanyName.push($scope.searchCompanies4);
                    $scope.selectedCompanyCode.push($scope.companyForSelected4);
                }

                if ($scope.selectedCompanyName.indexOf($scope.searchCompanies3) == -1 &&
                    $scope.searchCompanies3 != "" &&
                    $scope.searchCompanies3 != undefined &&
                    $scope.companyForSelected3 != undefined) {

                    $scope.selectedCompanyName.push($scope.searchCompanies3);
                    $scope.selectedCompanyCode.push($scope.companyForSelected3);
                }

                if ($scope.selectedCompanyName.indexOf($scope.searchCompanies2) == -1 &&
                    $scope.searchCompanies2 != "" &&
                    $scope.searchCompanies2 != undefined &&
                    $scope.companyForSelected2 != undefined) {

                    $scope.selectedCompanyName.push($scope.searchCompanies2);
                    $scope.selectedCompanyCode.push($scope.companyForSelected2);
                }

                for (var i = 0; i < $scope.selectedCompanyName.length; i++) {

                    if ($scope.selectedCompanyName[i] != $scope.searchCompanies4 &&
                        $scope.selectedCompanyName[i] != $scope.searchCompanies3 &&
                        $scope.selectedCompanyName[i] != $scope.searchCompanies2 &&
                        $scope.selectedCompanyName[i] != $scope.searchCompanies1) {

                        $scope.selectedCompanyName.splice(i, 1);
                        $scope.selectedCompanyCode.splice(i, 1);

                    }
                }

                $scope.allCompanies = $scope.selectedCompanyName;
                $scope.allCompaniesCode = $scope.selectedCompanyCode;

                $scope.comparePeerData();
            }
        }

        $scope.comparePeerData = function () {

            CompanyProfileService
                .getPeerInfoData($scope.allCompaniesCode).then(function (data) {
                    $scope.paramsValueData = [];
                    angular.forEach(data, function (company) {

                        $scope.paramsValueData.push(company.paramList);
                        if (company.paramsVal.length > 0) {
                            $scope.paramsList = company.paramsVal;

                        }
                    })
                });

        }

        // select company from filtered list

        $scope.selectCompany1 = function (companyObj) {
            $scope.error = false;
            $scope.searchCompanyerror1 = false;
            $scope.errorMessage = "";
            $scope.companyCodeForSelected1 = companyObj.companyName;
            $scope.companyForSelected1 = companyObj.companyCode;

            if ($scope.selectedCompanyName
                .indexOf($scope.companyCodeForSelected1) == -1 &&
                $scope.searchCompanies1 != "") {
                $scope.selectedCompanyName[0] = $scope.companyCodeForSelected1;
                $scope.selectedCompanyCode[0] = $scope.companyForSelected1;
                $scope.peerSuggestionButton = true;
                $scope.disablePeer1 = false;
            } else {
                $scope.searchCompanies1 = "";
                $scope.selectedCompanyName.splice(0, 1);
                $scope.error = true;
                $scope.peerSuggestionButton = false;
                $scope.errorMessage = "You have already selected this company, please choose a different one for comparison.";
                $timeout(function () {

                    $scope.error = false;
                    $scope.errorMessage = "";

                }, 2000);
            }

        }
        $scope.selectCompany2 = function (companyObj) {
            $scope.error = false;
            $scope.searchCompanyerror2 = false;
            $scope.errorMessage = "";
            $scope.companyCodeForSelected2 = companyObj.companyName;
            $scope.companyForSelected2 = companyObj.companyCode;
            $scope.searchCompanies2 = companyObj.companyName;
            if ($scope.selectedCompanyName
                .indexOf($scope.companyCodeForSelected2) == -1 &&
                $scope.searchCompanies2 != "") {
                $scope.selectedCompanyName.push($scope.companyCodeForSelected2);
                $scope.selectedCompanyCode.push($scope.companyForSelected2);
            } else {
                $scope.searchCompanies2 = "";
                $scope.selectedCompanyName.splice(1, 1);
                $scope.error = true;
                $scope.errorMessage = "You have already selected this company, please choose a different one for comparison.";
                $timeout(function () {

                    $scope.error = false;
                    $scope.errorMessage = "";

                }, 2000);
            }

        }
        $scope.selectCompany3 = function (companyObj) {
            $scope.error = false;
            $scope.errorMessage = "";
            $scope.searchCompanyerror3 = false;
            $scope.companyCodeForSelected3 = companyObj.companyName;
            $scope.companyForSelected3 = companyObj.companyCode;
            $scope.searchCompanies3 = companyObj.companyName;
            if ($scope.selectedCompanyName
                .indexOf($scope.companyCodeForSelected3) == -1 &&
                $scope.searchCompanies3 != "") {
                $scope.selectedCompanyName.push($scope.companyCodeForSelected3);
                $scope.selectedCompanyCode.push($scope.companyForSelected3);
            } else {
                $scope.searchCompanies3 = "";
                $scope.selectedCompanyName.splice(2, 1);
                $scope.error = true;
                $scope.errorMessage = "You have already selected this company, please choose a different one for comparison.";
                $timeout(function () {

                    $scope.error = false;
                    $scope.errorMessage = "";

                }, 2000);
            }

        }
        $scope.selectCompany4 = function (companyObj) {
            $scope.error = false;
            $scope.searchCompanyerror4 = false;
            $scope.errorMessage = "";
            $scope.companyCodeForSelected4 = companyObj.companyName;
            $scope.companyForSelected4 = companyObj.companyCode;
            $scope.searchCompanies4 = companyObj.companyName;
            if ($scope.selectedCompanyName
                .indexOf($scope.companyCodeForSelected4) == -1 &&
                $scope.companyCodeForSelected4 != "") {
                $scope.selectedCompanyName.push($scope.companyCodeForSelected4);
                $scope.selectedCompanyCode.push($scope.companyForSelected4);
            } else {
                $scope.searchCompanies4 = "";
                $scope.selectedCompanyName.splice(3, 1);
                $scope.error = true;
                $scope.errorMessage = "You have already selected this company, please choose a different one for comparison.";
                $timeout(function () {

                    $scope.error = false;
                    $scope.errorMessage = "";

                }, 2000);
            }

        }


        $scope.workingCapitalAllPeerComVal = [];
        $scope.searchCompaniesWorkingCap = {
            WoringCapital1: "",
            WoringCapital2: "",
            WoringCapital3: "",
            WoringCapital4: ""
        };
        $scope.workingCapitalValue = function () {
            $scope.workingCapitalAllPeerComVal = [];
            $scope.isNotNumber = false;

            if (($scope.segmentId == 19 || $scope.segmentId == 18)) {
                if (checkIsNumber()) {
                    $scope.selectedCompVal = {
                        companyCode: $scope.companyForSelected1,
                        workingCapitalVal: $scope.searchCompaniesWorkingCap.WoringCapital1
                    };

                    $scope.peerComp1Val = {
                        companyCode: $scope.companyForSelected2,
                        workingCapitalVal: $scope.searchCompaniesWorkingCap.WoringCapital2
                    };

                    $scope.peerComp2Val = {
                        companyCode: $scope.companyForSelected3,
                        workingCapitalVal: $scope.searchCompaniesWorkingCap.WoringCapital3
                    };

                    $scope.peerComp3Val = {
                        companyCode: $scope.companyForSelected4,
                        workingCapitalVal: $scope.searchCompaniesWorkingCap.WoringCapital4
                    };



                    $scope.workingCapitalAllPeerComVal.push($scope.selectedCompVal);
                    $scope.workingCapitalAllPeerComVal.push($scope.peerComp1Val);
                    $scope.workingCapitalAllPeerComVal.push($scope.peerComp2Val);
                    $scope.workingCapitalAllPeerComVal.push($scope.peerComp3Val);
                    $scope.workingCapitalAllPeerComVal.push($scope.peerComp4Val);
                }
            } else {
                $scope.isNotNumber = true;
            }

        }

        function checkIsNumber() {

            if ($scope.searchCompaniesWorkingCap.WoringCapital1 != '' && $scope.searchCompaniesWorkingCap.WoringCapital2 != '' && $scope.searchCompaniesWorkingCap.WoringCapital3 != '' &&
                $scope.searchCompaniesWorkingCap.WoringCapital4 != '') {

                if (!isNaN($scope.searchCompaniesWorkingCap.WoringCapital1) && !isNaN($scope.searchCompaniesWorkingCap.WoringCapital2) &&
                    !isNaN($scope.searchCompaniesWorkingCap.WoringCapital3) && !isNaN($scope.searchCompaniesWorkingCap.WoringCapital4)
                ) {
                    $scope.isNotNumber = true;
                    return true;
                }
            }
            return false;
        }

        $scope.downloadCompanyReportFinal = function () {
            angular.forEach(vm.selectedirsIndustry, function (val, key) {

                $scope.finalIrsIndustryId.push(val.labelName);
            });
            var promise = GenericService.getMaximumRevenuLimit();
            promise
                .then(
                    function (data) {
                        if (data != 0) {
                            $scope.upperlimitval = (data / 100).toFixed(0);
                            $scope.upperlimit = $filter('number')($scope.upperlimitval, 0);
                            if ($scope.idStack.length == 0) {
                                $scope.idStack.push($scope.industryId);

                            } else {

                                $scope.industryId = $scope.idStack[0]
                            }

                            if ($scope.selectedIndustries.length != 0) {
                                $scope.NameOfIndustry = $scope.selectedIndustries[0];
                            } else {

                                $scope.NameOfIndustry = $scope.industryName;

                            }

                            var litigationStr = 'pending'
                            if ($scope.flag.litigationFlag) {
                                litigationStr = 'all'
                            }

                            $scope.companiesData = {
                                companyCode: $scope.companyCode,
                                industryIdList: $scope.idStack.toString(),
                                industryId: $scope.industryId,
                                maxRevenue: $scope.upperlimitval,
                                companyName: $scope.companyName,
                                listingStatus: $scope.ListingStatus,
                                industryName: $scope.NameOfIndustry,
                                listOfCompanyCodes: $scope.allCompaniesCode,
                                irsIndustryName: $scope.finalIrsIndustryId,
                                workingCapitalValAllPeer: $scope.workingCapitalAllPeerComVal,
                                nonGstFlag: $scope.flag.nonGstFlag,
                                epfTransactionStart: $scope.range.start,
                                epfTransactionEnd: $scope.range.end,
                                litigationToggleFlag: $scope.flag.litigationToggleFlag,
                                litigationFlag: litigationStr,
                                epfToggleFlag: $scope.flag.epfToggleFlag,
                                fuzzyFlag: $scope.flag.fuzzyFlag,
								litigationsLinkedFlag:$scope.flag.litigationsLinkedFlag,
								selectedpromotorsdirectorList:$scope.directorpromotorlist

                            }


                            $http({
                                    url: 'api/companyProfile/downloadCompanyDetailReport',
                                    method: 'POST',
                                    data: $scope.companiesData,
                                    responseType: 'arraybuffer'
                                })
                                .success(

                                    function (response) {
                                        var isIE = false || !!document.documentMode;
                                        $scope.response = response;
                                        var templateName = $scope.companyName + " Company Report.xlsx";
                                        var blob = new Blob(
                                            [response], {
                                                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                            });
                                        if (isIE) {

                                            window.navigator
                                                .msSaveOrOpenBlob(
                                                    blob,
                                                    'Company Details Template.xlsx');

                                        } else {

                                            var anchor = angular
                                                .element('<a/>');
                                            var blob = new Blob(
                                                [response], {
                                                    type: 'application/vnd.ms-excel'
                                                })
                                            var objectUrl = (window.URL || window.webkitURL)
                                                .createObjectURL(blob);
                                            anchor.css({
                                                display: 'none'
                                            });
                                            // Make sure it's not
                                            // visible
                                            angular.element(
                                                    document.body)
                                                .append(anchor); // Attach
                                            // to
                                            // document
                                            anchor
                                                .attr({
                                                    href: objectUrl,
                                                    target: '_self',

                                                    download: templateName
                                                })[0].click();

                                            anchor.remove();

                                        }

                                    })

                        }
                    },
                    function (response, status, headers, config) {});

        }

        $scope.getIrsIndustryName();


        $scope.changedlitigationFlag = function () {
            $scope.flag.litigationFlag = false;
        }

        $scope.directorpromotorlist = [{
            'id': 1
        }];
        $scope.errordirprosize = null;
        $scope.changedLitigationLinkedFlag = function () {
            if ($scope.flag.litigationsLinkedFlag) {
                $scope.directorpromotorlist = [{
                    'id': 1
                }];
                $scope.errordirprosize = null;
            }

        }
        $scope.addirectorpromotor = function () {
            if ($scope.directorpromotorlist.length < 5) {
                var newid = $scope.directorpromotorlist.length + Math.floor(Math.random() * 100) + 1;
                $scope.directorpromotorlist.push({
                    'id': newid
                });
                $scope.errordirprosize = null;
            } else {
                $scope.errordirprosize = " Can Not Add More than Five  Director / Promoters";
                $timeout(function () {
                    $scope.errordirprosize = "";
                }, 2000);
            }

        };

        $scope.removedirectorpromotor = function (item) {

            for (var i = $scope.directorpromotorlist.length; i--;) {
                if ($scope.directorpromotorlist[i].id === item) {
                    $scope.directorpromotorlist.splice(i, 1);
                }
            }
            if ($scope.directorpromotorlist.length == 0) {
                $scope.flag.litigationsLinkedFlag = false;

            }
        }






    }




})();
